import React from 'react';

/**
 * Minimal markdown-to-JSX renderer.
 * Supports: **bold**, `code`, ```code blocks```, - lists, and line breaks.
 * No external dependencies.
 */

export function renderMarkdown(text) {
  if (!text) return null;

  const lines = text.split('\n');
  const elements = [];
  let inCodeBlock = false;
  let codeLines = [];
  let key = 0;

  for (const line of lines) {
    if (line.trim().startsWith('```')) {
      if (inCodeBlock) {
        elements.push(
          <pre key={key++} className="bg-black/20 rounded p-3 my-2 overflow-x-auto text-sm font-mono">
            <code>{codeLines.join('\n')}</code>
          </pre>
        );
        codeLines = [];
        inCodeBlock = false;
      } else {
        inCodeBlock = true;
      }
      continue;
    }

    if (inCodeBlock) {
      codeLines.push(line);
      continue;
    }

    if (line.trim().startsWith('- ')) {
      elements.push(
        <li key={key++} className="ml-4 list-disc">
          {renderInline(line.trim().slice(2))}
        </li>
      );
    } else if (line.trim() === '') {
      elements.push(<br key={key++} />);
    } else {
      elements.push(
        <p key={key++} className="my-1">
          {renderInline(line)}
        </p>
      );
    }
  }

  return <>{elements}</>;
}

function renderInline(text) {
  // Process **bold** and `code` inline
  const parts = [];
  let remaining = text;
  let key = 0;

  while (remaining.length > 0) {
    // Check for `code`
    const codeMatch = remaining.match(/^(.*?)`([^`]+)`(.*)$/s);
    // Check for **bold**
    const boldMatch = remaining.match(/^(.*?)\*\*([^*]+)\*\*(.*)$/s);

    if (codeMatch && (!boldMatch || codeMatch.index <= boldMatch.index)) {
      if (codeMatch[1]) parts.push(codeMatch[1]);
      parts.push(
        <code key={key++} className="bg-black/20 px-1.5 py-0.5 rounded text-sm font-mono">
          {codeMatch[2]}
        </code>
      );
      remaining = codeMatch[3];
    } else if (boldMatch) {
      if (boldMatch[1]) parts.push(boldMatch[1]);
      parts.push(<strong key={key++}>{boldMatch[2]}</strong>);
      remaining = boldMatch[3];
    } else {
      parts.push(remaining);
      remaining = '';
    }
  }

  return parts;
}
